import React from 'react';
import SimpleMenuItem from '../SimpleMenuItem/index';
import { SimpleSubMenuContainer } from './styles';
import handleSamePathClick from '../utils/handleSamePathClick';

const SimpleSubMenu = ({ isMenuOpened, setMobileMenuOpened, subNavElements = [] }) => {
  return (
    <SimpleSubMenuContainer
      data-testid="simple-sub-menu"
      className="simple-menu"
      isMenuOpened={isMenuOpened}
    >
      {subNavElements.map((subMenuItem, index) => {
        return (
          <SimpleMenuItem
            type={subMenuItem.label?.includes('See All') ? 'footer' : 'icon-title-desc'}
            icon={
              subMenuItem.icon &&
              subMenuItem.icon.image &&
              subMenuItem.icon.image.file &&
              subMenuItem.icon.image.file.url
            }
            alt={subMenuItem.icon && subMenuItem.icon.alt}
            title={subMenuItem.label}
            link={subMenuItem.url}
            key={index}
            onClick={() => handleSamePathClick(subMenuItem.url, setMobileMenuOpened)}
          />
        );
      })}
    </SimpleSubMenuContainer>
  );
};

export default SimpleSubMenu;
